
import { connect } from 'react-redux';
import AbsenceToolbar from '../../components/absence/absence-toolbar';
import { downloadCSV, uploadCSV } from './absence-actions';

const mapDispatchToProps = {
  downloadCSV,
  uploadCSV,
};

const mapStateToProps = state => ({
  menuVisible: state.header.menuVisible,
  isLoadingPlants: state.absence.isLoadingPlants,
  isLoadingData: state.absence.isLoadingData,
  isUploading: state.absence.isUploading,
  uploadSuccess: state.absence.uploadSuccess,
  uploadFailure: state.absence.uploadFailure,
});

export default connect(mapStateToProps, mapDispatchToProps)(AbsenceToolbar);

